import fetch from '../../../core/fetch';
import showToaster from '../../../helpers/toasterMessages/showToaster';
import { demoRestriction } from '../../../helpers/DemoRestriction/demoRestriction';

async function submit(values, dispatch) {
  const isRestrict = await dispatch(demoRestriction({}));
  if (isRestrict) return;

  const dynamicFooterBlock = values?.dynamicFooterBlock?.filter(
    item => item && item.language
  );

  const query = `
    mutation (
      $title1: String,
      $content1: String,
      $title2: String,
      $content2: String,
      $title3: String,
      $content3: String,
      $dynamicFooterBlock: String
    ) {
      CreateFooterSetting (
        title1: $title1,
        content1: $content1,
        title2: $title2,
        content2: $content2,
        title3: $title3,
        content3: $content3,
        dynamicFooterBlock: $dynamicFooterBlock
      ) {
        status
      }
    }
  `;

  const resp = await fetch('/graphql', {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      query,
      variables: {
        title1: dynamicFooterBlock?.[0]?.title1,
        content1: dynamicFooterBlock?.[0]?.content1,
        title2: dynamicFooterBlock?.[0]?.title2,
        content2: dynamicFooterBlock?.[0]?.content2,
        title3: dynamicFooterBlock?.[0]?.title3,
        content3: dynamicFooterBlock?.[0]?.content3,
        dynamicFooterBlock: JSON.stringify(dynamicFooterBlock),
      }
    }),
    credentials: 'include',
  });

  const { data } = await resp.json();

  if (data.CreateFooterSetting.status === "success") {
    showToaster({ messageId: 'footerSettingsUpdate', toasterType: 'success' })
  } else {
    showToaster({ messageId: 'footerSettingsUpdateFailed', toasterType: 'error' })
  }
}

export default submit;